export default {
  badge: 'תג',
  open: 'פתח',
  close: 'סגור',
  dismiss: 'התעלם',
  confirmEdit: {
    ok: 'אישור',
    cancel: 'ביטול',
  },
  dataIterator: {
    noResultsText: 'לא נמצאו תוצאות מתאימות',
    loadingText: 'טוען פריט...',
  },
  dataTable: {
    itemsPerPageText: 'שורות לעמוד:',
    ariaLabel: {
      sortDescending: 'ממוין לפי סדר עולה. לחץ להספקת המיון.',
      sortAscending: 'ממוין לפי סדר יורד. לחץ למיון לפי סדר עולה.',
      sortNone: 'לא ממוין. לחץ למיון לפי סדר עולה.',
      activateNone: 'הפעל להסרת המיון.',
      activateDescending: 'הפעל למיון יורד.',
      activateAscending: 'הפעל למיון עולה.',
    },
    sortBy: 'סדר לפי',
  },
  dataFooter: {
    itemsPerPageText: 'פריטים לדף:',
    itemsPerPageAll: 'הכל',
    nextPage: 'עמוד הבא',
    prevPage: 'עמוד הקודם',
    firstPage: 'עמוד ראשון',
    lastPage: 'עמוד אחרון',
    pageText: '{0}-{1} מתוך {2}',
  },
  dateRangeInput: {
    divider: 'עד',
  },
  datePicker: {
    itemsSelected: '{0} נבחר',
    range: {
      title: 'בחר תאריכים',
      header: 'הזן תאריכים',
    },
    title: 'בחר תאריך',
    header: 'הזן תאריך',
    input: {
      placeholder: 'הזן תאריך',
    },
    ariaLabel: {
      previousMonth: 'החודש הקודם',
      nextMonth: 'החודש הבא',
      selectYear: 'בחר שנה',
      previousYear: 'השנה הקודמת',
      nextYear: 'השנה הבאה',
      selectMonth: 'בחר חודש',
      selectDate: '{0}',
      currentDate: 'היום, {0}',
    },
  },
  noDataText: 'אין נתונים זמינים',
  carousel: {
    prev: 'מצג קודם',
    next: 'מצג הבא',
    ariaLabel: {
      delimiter: 'שקופית {0} מתוך {1}',
    },
  },
  calendar: {
    moreEvents: '{0} נוספים',
    today: 'היום',
  },
  input: {
    clear: 'נקה {0}',
    prependAction: '{0} פעולה מקדימה',
    appendAction: '{0} פעולה נוספת',
    otp: 'נא להזין תו OTP {0}',
  },
  fileInput: {
    counter: '{0} קבצים',
    counterSize: '{0} קבצים ({1} בסך הכל)',
  },
  fileUpload: {
    title: 'גרור ושחרר קבצים כאן',
    divider: 'או',
    browse: 'עיון בקבצים',
  },
  timePicker: {
    am: 'לפנה"צ',
    pm: 'אחה"צ',
    title: 'בחר שעה',
    hour: 'שעה',
    minute: 'דקות',
    second: 'שניות',
  },
  pagination: {
    ariaLabel: {
      root: 'ניווט עימוד',
      next: 'עמוד הבא',
      previous: 'עמוד הקודם',
      page: '{0} לך לעמוד',
      currentPage: '{0} עמוד נוכחי, עמוד',
      first: 'First page',
      last: 'Last page',
    },
  },
  stepper: {
    next: 'הבא',
    prev: 'הקודם',
  },
  rating: {
    ariaLabel: {
      item: 'דירוג {0} מתוך {1}',
    },
  },
  loading: 'טוען...',
  infiniteScroll: {
    loadMore: 'טען עוד',
    empty: 'אין עוד נתונים',
  },
  rules: {
    required: 'שדה זה נדרש',
    email: 'נא להזין כתובת דוא"ל תקפה',
    number: 'שדה זה יכול להכיל רק מספרים',
    integer: 'שדה זה יכול להכיל רק ערכים שלמים',
    capital: 'שדה זה יכול להכיל רק אותיות רישיות',
    maxLength: 'יש להזין מקסימום {0} תווים',
    minLength: 'יש להזין מינימום {0} תווים',
    strictLength: 'אורך השדה שהוזן אינו תקף',
    exclude: 'התו {0} אינו מותר',
    notEmpty: 'נא לבחור לפחות ערך אחד',
    pattern: 'פורמט לא תקף',
  },
  hotkey: {
    then: 'אז',
    ctrl: 'Ctrl',
    command: 'Command',
    shift: 'Shift',
    alt: 'Alt',
    option: 'Option',
    enter: 'Enter',
    escape: 'Escape',
    upArrow: 'חץ למעלה',
    downArrow: 'חץ למטה',
    leftArrow: 'חץ שמאלה',
    rightArrow: 'חץ ימינה',
    backspace: 'Backspace',
    space: 'רווח',
    plus: 'פלוס',
    shortcut: 'קיצור דרך במקלדת: {0}',
    or: 'או',
  },
  video: {
    play: 'נגן',
    pause: 'השהה',
    seek: 'חפש',
    volume: 'עוצמת שמע',
    showVolume: 'הצג בקרת עוצמת שמע',
    mute: 'השתק',
    unmute: 'בטל השתקה',
    enterFullscreen: 'מסך מלא',
    exitFullscreen: 'צא ממסך מלא',
  },
  colorPicker: {
    ariaLabel: {
      eyedropper: 'בחר צבע מהמסך',
      hueSlider: 'גוון',
      alphaSlider: 'אלפא',
      redInput: 'אדום',
      greenInput: 'ירוק',
      blueInput: 'כחול',
      alphaInput: 'אלפא',
      hueInput: 'גוון',
      saturationInput: 'רוויה',
      lightnessInput: 'בהירות',
      hexInput: 'ערך HEX',
      hexaInput: 'HEX עם ערך אלפא',
      changeFormat: 'שנה פורמט צבע',
    },
  },
}
